<div class="flex grow" [class.app-sidebar-collapsed]="sidebarCollapsed()">
  <app-header></app-header>

  <div class="flex flex-col lg:flex-row grow min-h-screen lg:h-screen pt-(--header-height) lg:pt-0">
    <app-sidebar></app-sidebar>

    @if (sidebarCollapsed()) {
      <button
        type="button"
        class="sidebar-reopen-btn"
        (click)="onExpandSidebar()"
        aria-label="Open sidebar"
        title="Open sidebar"
      >
        <i class="ki-filled ki-black-right" aria-hidden="true"></i>
      </button>
    }

    <div class="app-content flex min-w-0 min-h-0 flex-col grow lg:rounded-l-xl bg-background border border-input lg:ms-(--sidebar-width)">
      <div class="flex min-h-0 flex-col grow pt-5">
        <main class="flex min-h-0 flex-col grow overflow-y-auto lg:[--kt-scrollbar-width:auto]" id="scrollable_content" role="main">
          <router-outlet></router-outlet>
        </main>

        <app-footer></app-footer>
      </div>
    </div>
  </div>
</div>